export default __webpack_public_path__ + "static/media/bg3.67765cf1.jpg";